<template>
    <v-container fluid fill-height>
        <v-layout align-center justify-center row pa-5>
            <v-flex xs12 sm10 md6 text-center>
                <div class="mb-5">
                    <h1>ค้นหาพัสดุ</h1>
                </div>
                <div>
                    <v-text-field
                            label="Search"
                            placeholder="ชื่อ-สกุล,ยูนิต,บ้านเลขที่,โทร,เลขอ้างอิง"
                            outlined
                            append-icon="mdi-barcode-scan"
                            @keypress.enter="goto('parcel-list')"
                            @click:append="goto('barcode-scan')"
                            v-model="searchText"
                    ></v-text-field>
<!--                    <v-text-field-->
<!--                            label="Search"-->
<!--                            placeholder="ชื่อ-สกุล,ยูนิต,บ้านเลขที่,โทร,เลขอ้างอิง"-->
<!--                            outlined-->
<!--                            @keypress.enter="goto('parcel-list')"-->
<!--                            v-model="searchText"-->
<!--                    ></v-text-field>-->
                </div>
                <div>
                    <v-btn color="#1565C0"
                           block
                           large
                           dark
                           @click="goto('parcel-list')"
                           style="font-size: 19px;">
                        ค้นหา
                    </v-btn>
                </div>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import EventBus from '@/EventBus'

    export default {
        name      : 'search-parcel',
        components: {},
        data() {
            return {
                searchText: ''
            }
        },
        mounted() {
            window.scrollTo(0, 0)
            EventBus.$emit('set_navigation', {title: 'บันทึกจ่ายพัสดุ', back_route: 'main-menu'});

            let localItem = this.getLocalItem();
            delete localItem.itemSelected;
            delete localItem.itemsParcel;
            delete localItem.searchText;
            delete localItem.QRref;
            localStorage.setItem('parcel', JSON.stringify(localItem))
        },
        methods   : {
            goto(route_name, params) {
                if (route_name == 'logout') {
                    EventBus.$emit('resetToken')
                    return this.logout()
                } else {
                    if (params) {
                        EventBus.$emit(params.eventbus_call, params.params)
                    }
                    if (route_name == 'parcel-list') {
                        let parcel = this.getLocalItem();
                        parcel.searchText = this.searchText
                        localStorage.setItem('parcel', JSON.stringify(parcel))
                    }
                    return this.$router.push({name: route_name})
                }
            }
        }
    }
</script>
